export default [
  {
    path: '/admin/pension-rates',
    name: 'pension-rates',
    meta: { requiresAuth: true },
    component: () => import('@/pages/payroll/pension-rate/index.vue')
  }
]
